import React from "react";

function Video(props) {
  const { sections } = props;

  const className =
    props.current === props.video.id
      ? "list-group-item list-group-item-action active"
      : "list-group-item list-group-item-action";

  const secondsToHms = d => {
    d = Number(d);
    const h = Math.floor(d / 3600);
    const m = Math.floor((d % 3600) / 60);
    const s = Math.floor((d % 3600) % 60);

    const hDisplay = h > 0 ? h + (h === 1 ? " hour, " : ":") : "";
    const mDisplay = m > 0 ? m + (m === 1 ? " :00 " : ":") : "0:";
    const sDisplay = s > 0 ? s + (s === 1 ? " second" : "") : "";

    return hDisplay + mDisplay + sDisplay;
  };

  return (
    <button
      className={className}
      type="button"
      value={props.video.id}
      key={props.video.id}
      onClick={e => props.handleVideoSelect(e, sections)}
    >
      <span className="item-progress">
        {props.video.isCompleted ? (
          <i className="fas fa-check-circle" />
        ) : (
          <i className="far fa-circle" />
        )}
      </span>
      <span>
        <i className="far fa-play-circle" />{" "}
      </span>

      <span>{props.video.name}</span>

      <span>
        <small>{`(${secondsToHms(props.video.duration)})`}</small>
      </span>
    </button>
  );
}

export default Video;
